export default "__VITE_ASSET__BkRBSpeO__"